<template>
    <div class="dropbox">
        <core-loader
            class="overlayer"
            v-if="isLoading"
            :status="isLoading" />
        <label
            class="dropzone"
            for="file-default"
            @dragenter="dragEnter"
            @dragleave="dragLeave"
            @drop="dragLeave"
            :class="{ 'file-hover': fileHover }"
        >
            <span>Sleep je bestand hiereen <strong>of</strong> klik om een bestand te uploaden.</span>

            <button
                type="button"
                class="btn btn-outline-dark">

                <input
                    id="file-default"
                    @change="filesChanged"
                    class="fileInput"
                    type="file"
                    multiple
                    name="file1"
                />
            </button>
        </label>
    </div>
</template>
<script>

export default {
    data() {
        return {
            counter: 0,
            fileHover: false,
            isLoading: null,
            uploadFiles: []
        };
    },
    props: {
        url: {
            type: String,
            default: ''
        }
    },
    methods: {
        dragEnter(ev) {
            ev.preventDefault(); // needed for IE
            this.counter++;
            this.fileHover = true;
        },
        dragLeave(ev) {
            this.counter--;
            if (this.counter === 0) {
                this.fileHover = false;
            }
        },
        filesChanged(e) {
            var fileList = e.target.files || e.dataTransfer.files;
            var numberOfFiles = fileList.length;
            var titleSuccess = '';
            if (!numberOfFiles) return;
            if (numberOfFiles > 1) {
                this.isLoading = `${numberOfFiles} Bestanden worden geupload`;
                titleSuccess = `${numberOfFiles} Bestanden succesvol geupload`;
            } else {
                this.isLoading = '1 bestand wordt geupload';
                titleSuccess = '1 bestand succesvol geupload';
            }
            const files = [...fileList];


            let formData = new FormData();
            formData.append('file', files[0])

            this.$inertia.post(this.url, formData).then(() => {
                this.isLoading = false
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.dropbox {
    position: relative;

    .dropzone {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 300px;
        border: 1px dashed var(--border-blue-50);
        background-color: var(--bg-white);
        cursor: pointer;


        &:hover {
            border-color: var(--primary);
        }

        & > * {
            margin: 0.5rem 0;
        }

        .btn {
            position: initial;
            cursor: pointer;

            input[type='file'],
            input[type='file']::-webkit-file-upload-button {
                cursor: pointer;
            }
        }

        .inputWrapper {
            position: relative;
            width: 64px;
            height: 32px;
            overflow: hidden;
            cursor: pointer;
        }

        .fileInput {
            position: absolute;
            z-index: 99;
            top: 0;
            right: 0;
            width: 100%;
            height: 100%;
            -moz-opacity: 0;
            opacity: 0;
            background-color: red;
            font-size: 50px;
            cursor: pointer;
            filter: progid:dximagetransform.microsoft.alpha(opacity=0);
        }
    }
}
</style>
